import { render, staticRenderFns } from "./DeleteDescuentoModal.vue?vue&type=template&id=20d935f2"
import script from "./DeleteDescuentoModal.vue?vue&type=script&lang=js"
export * from "./DeleteDescuentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports